import {
  getRemoteConfig,
  fetchAndActivate,
  getBoolean,
  getString,
  getNumber,
} from 'firebase/remote-config';

import { initializeFirebaseWeb } from '@/adapters/pushNotification/firebaseInitialization.web';
import { sentryLogger } from '@/adapters/logger/sentryLogger';

import { REMOTE_CONFIG_DEFAULTS, MINIMUM_FETCH_INTERVAL_MILLIS } from './defaults';
import type { RemoteConfigAdapter } from './types';

const createRemoteConfigAdapter = (): RemoteConfigAdapter => {
  const state: { instance: ReturnType<typeof getRemoteConfig> | null } = { instance: null };

  const getConfig = () => {
    if (!state.instance) {
      const instance = getRemoteConfig(initializeFirebaseWeb());
      instance.settings.minimumFetchIntervalMillis = MINIMUM_FETCH_INTERVAL_MILLIS;
      instance.defaultConfig = REMOTE_CONFIG_DEFAULTS;
      state.instance = instance;
    }
    return state.instance;
  };

  return {
    fetchAndActivate: async () => {
      try {
        return await fetchAndActivate(getConfig());
      } catch (error) {
        sentryLogger.captureException(error);
        return false;
      }
    },
    getBoolean: async (key) => getBoolean(getConfig(), key),
    getString: async (key) => getString(getConfig(), key),
    getNumber: async (key) => getNumber(getConfig(), key),
    onConfigUpdate: () => () => {},
  };
};

export const remoteConfigAdapter = createRemoteConfigAdapter();
